import { render, staticRenderFns } from "./PapercleandDocumentiEditModalComponent.vue?vue&type=template&id=e9be1aa2&scoped=true"
import script from "./PapercleandDocumentiEditModalComponent.vue?vue&type=script&lang=js"
export * from "./PapercleandDocumentiEditModalComponent.vue?vue&type=script&lang=js"
import style0 from "./PapercleandDocumentiEditModalComponent.vue?vue&type=style&index=0&id=e9be1aa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9be1aa2",
  null
  
)

export default component.exports